export default {
	english:{
		red: {
			headline: <>Give your money a $325&nbsp;bonus</>,
			subHead: "when you open a new, checking account with qualifying direct deposits.",
			// copy: "Get Fargo and a lot more.",
			cta: "Get started",
		},
		white: {
			headline: "Want a $325 bonus?",
			subHead: "Open a new, eligible checking account with qualifying direct deposits.",
			cta: "Get started",
		}
	},
	spanish:{
		red: {
			headline: "Disfruta un bono de $325",
			subHead: "al abrir una nueva cuenta de cheques elegible con depósitos directos que califiquen.",
			cta: "Comienza ya",
			alt: "Comienza ya - abre en una nueva ventana del navegador"
		},
		white: {
			headline: "¿Quieres un bono de $325?",
			subHead: "Abre una nueva cuenta de cheques elegible con depósitos directos que califiquen.",
			cta: "Comienza ya (en inglés)",
			alt: "Comienza ya - abre en una nueva ventana del navegador"
		}
	}
};
